module.exports = __webpack_public_path__ + "static/img/IMG_00006.bf6f7fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf1/IMG_00006.png
// module id = QvDf
// module chunks = 7